import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../store/auth';

const routes = [
  { path: '/', name: 'home', component: () => import('../views/HomeView.vue') },
  {
    path: '/login',
    name: 'login',
    redirect: (to) => ({ name: 'home', query: { ...to.query, login: '1' } }),
    meta: { guestOnly: true },
  },
  { path: '/register', name: 'register', component: () => import('../views/RegisterView.vue'), meta: { guestOnly: true } },
  { path: '/forgot-password', name: 'forgot-password', component: () => import('../views/ForgotPasswordView.vue'), meta: { guestOnly: true } },
  { path: '/reset-password', name: 'reset-password', component: () => import('../views/ResetPasswordView.vue'), meta: { guestOnly: true } },
  { path: '/privacy', name: 'privacy', component: () => import('../views/PrivacyPolicyView.vue') },
  { path: '/guidelines', name: 'guidelines', component: () => import('../views/CommunityGuidelinesView.vue') },
  { path: '/browse', name: 'browse', component: () => import('../views/BrowseView.vue'), meta: { requiresAuth: true } },
  { path: '/listings/new', name: 'listing-new', component: () => import('../views/CreateListingView.vue'), meta: { requiresAuth: true, requiresSubscription: true } },
  { path: '/listings/mine', name: 'listing-mine', component: () => import('../views/MyListingsView.vue'), meta: { requiresAuth: true } },
  { path: '/offers', name: 'offers', component: () => import('../views/OffersView.vue'), meta: { requiresAuth: true } },
  { path: '/notifications', name: 'notifications', component: () => import('../views/NotificationsView.vue'), meta: { requiresAuth: true } },
  { path: '/profile', name: 'profile', component: () => import('../views/ProfileView.vue'), meta: { requiresAuth: true } },
  { path: '/billing', name: 'billing', component: () => import('../views/BillingView.vue'), meta: { requiresAuth: true } },
  { path: '/admin', name: 'admin', component: () => import('../views/AdminView.vue'), meta: { requiresAuth: true, requiresAdmin: true } },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('../views/NotFoundView.vue') },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  if (auth.token && !auth.user && !auth.hydrated) {
    await auth.fetchMe();
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'home', query: { redirect: to.fullPath } };
  }
  if (to.meta.guestOnly && auth.isAuthenticated) {
    return { name: 'browse' };
  }
  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return { name: 'browse' };
  }
  if (to.meta.requiresSubscription && !auth.hasActiveSubscription) {
    return { name: 'billing' };
  }
  return true;
});

router.afterEach((to) => {
  if (to.meta.requiresAuth) {
    localStorage.setItem('bm_last_authed_route', to.fullPath);
  }
});

export default router;
